import { useDispatch } from 'react-redux';
import { BoundRuler2dState, UpdatedKeys } from '../reducers/ruler2d.reducer';
import * as ruler2dActions from '../actions/ruler2d.actions';

export const useUpdateByBoundary = () => {
  const dispatch = useDispatch();
  return (
    event: React.MouseEvent,
    boundaryAxis: keyof Pick<BoundRuler2dState, 'xBoundary' | 'yBoundary'>,
    boundary: UpdatedKeys,
  ) => {
    event.preventDefault();
    if (event.button !== 0) {
      return;
    }
    dispatch(ruler2dActions.setBoundary({ [boundaryAxis]: boundary }));
  };
};
